import { render, staticRenderFns } from "./RightsTable.vue?vue&type=template&id=67fa1c49"
import script from "./RightsTable.vue?vue&type=script&lang=js"
export * from "./RightsTable.vue?vue&type=script&lang=js"
import style0 from "./RightsTable.vue?vue&type=style&index=0&id=67fa1c49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VIcon,VProgressCircular,VTooltip})
